import { MobileService } from '@/store/slice/mobile-tariff.slice';
import {
  BUILDING_TYPE,
  HOME_INTERNET_SERVICE_TYPE,
  ServiceHomeInternetEntity,
} from '@/store/api/service-home-internet/service-home-internet.type';
import { ServiceHomeInternetSliceItem } from '@/store/slice/home-internet.slice';
import { TariffCardOptionProps } from '@/shared/ui-kit/tariff-card/tariff-card-option/tariff-card-option.types';
import { TariffOptionIcon } from '@/modules/tariff/shared/constants';
import { ServiceHomeInternetMapperArgs } from '.';


export const homeInternetServiceToMobileService = ({
  item,
  added,
}: {
  item: Omit<ServiceHomeInternetSliceItem, 'added'>;
  added: boolean;
}): MobileService => ({
  servicePrice: item.prices.convergent_price || 0,
  title: item.localized_name,
  serv_id: item?.serv_id || item.shpd_id,
  shpd_serv_id: item.shpd_id,
  description: item.description,
  added,
  id: item.shpd_id, //
});

export const serviceItemToTariffCardOptionProps = (arr: ServiceHomeInternetSliceItem[]): TariffCardOptionProps[] =>
  arr.map(({ service_type, localized_name }) => ({
    icon: service_type === HOME_INTERNET_SERVICE_TYPE.SPEED ? TariffOptionIcon.Speed : TariffOptionIcon.Tv,
    value: localized_name?.split(' ')[0],
    text: localized_name?.split(' ')[1],
  })
);

  export const serviceHomeInternetMapper = ({ attributes, id, added }: ServiceHomeInternetMapperArgs): ServiceHomeInternetSliceItem => ({
  id,
  added,
  name: attributes.name,
  localized_name: attributes.localized_name,
  shpd_id: attributes.shpd_id,
  old_shpd_id: attributes.old_shpd_id,
  building_type: attributes.building_type,
  service_type: attributes.service_type,
  prices: attributes.prices,
  description: attributes.description,
  promotion_period: attributes.promotion_period,
  promotion_description: attributes.promotion_description,
  affects_promotion_shpd_mobile_ids: attributes.affects_promotion_shpd?.data?.map(({ id }) => id),
  default_tariff_home_internets: attributes.default_tariff_home_internets?.data?.map(({ id }) => id),
  background_image: attributes.background_image?.data?.attributes?.url,
  serv_id: attributes.service?.data?.attributes?.serv_id,
});

export const serviceHomeInternetResponseMapper = (data?: ServiceHomeInternetEntity | null, added?: boolean) : ServiceHomeInternetSliceItem[] | undefined => {
  return data?.data?.map(({ attributes, id }) => serviceHomeInternetMapper({ attributes, id, added }));
};

export const homeInternetDefaultServicesMapper = (default_services?: ServiceHomeInternetEntity | null, buildingType?: BUILDING_TYPE) => {
  const mappedServices = serviceHomeInternetResponseMapper(default_services, true);
  const defaultSpeed = mappedServices?.find(({ service_type, building_type }) => 
    service_type === HOME_INTERNET_SERVICE_TYPE.SPEED && 
    building_type === (buildingType || BUILDING_TYPE.APARTMENT)
  );
  const defaultTv = mappedServices?.find(({ service_type }) =>
    service_type === HOME_INTERNET_SERVICE_TYPE.TV
  );
  const defaultServices = mappedServices?.filter(({ service_type }) =>
    service_type !== HOME_INTERNET_SERVICE_TYPE.SPEED &&
    service_type !== HOME_INTERNET_SERVICE_TYPE.TV &&
    service_type !== HOME_INTERNET_SERVICE_TYPE.KINOMANIYA
  );
  const kinomaniyaServices = mappedServices?.filter(({ service_type }) =>
    service_type === HOME_INTERNET_SERVICE_TYPE.KINOMANIYA
  );

  return {
    defaultSpeed,
    defaultTv,
    defaultServices,
    kinomaniyaServices
  }
};
